/**
 * ChatTurn — single chat message bubble in the Blueprint chat surface.
 *
 * Two roles: 'user' (right-aligned, navy fill, white text) and 'assistant'
 * (left-aligned, white surface, navy border, body-serif text matching the
 * conversation-first prose-heavy posture per the engine constraints).
 *
 * The assistant variant is the primary surface for chat output, so it uses
 * the locked Lora body type. User turns use the UI sans-serif.
 */

export default function ChatTurn({ role, children, timestamp }) {
  const isUser = role === "user";
  return (
    <div
      style={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        marginBottom: 14,
      }}
      data-component="ChatTurn"
      data-role={role}
    >
      <div
        style={{
          maxWidth: "85%",
          padding: "12px 16px",
          background: isUser
            ? "var(--ppr-color-accent-navy)"
            : "var(--ppr-color-background-surface)",
          border: isUser
            ? "1px solid var(--ppr-color-border-default)"
            : "1px solid var(--ppr-color-border-default)",
          color: isUser
            ? "var(--ppr-color-text-inverse)"
            : "var(--ppr-color-text-primary)",
          fontFamily: isUser
            ? "var(--ppr-typography-font-family-ui)"
            : "var(--ppr-typography-font-family-body)",
          fontSize: "var(--ppr-typography-font-size-base)",
          lineHeight: "var(--ppr-typography-line-height-relaxed)",
        }}
      >
        {children}
        {timestamp ? (
          <div
            style={{
              marginTop: 6,
              fontFamily: "var(--ppr-typography-font-family-mono)",
              fontSize: "10.5px",
              color: isUser
                ? "var(--ppr-color-accent-pale)"
                : "var(--ppr-color-text-muted)",
              letterSpacing: "0.02em",
            }}
          >
            {timestamp}
          </div>
        ) : null}
      </div>
    </div>
  );
}
